<template>
  <div class="app-container">
    <!-- 菜单部分 - 保持在顶部 -->
    <div class="menu-section">
      <div class="menu-container">
        <!-- 一级菜单 -->
        <div class="first-level-menu">
          <div
              v-for="(item, index) in menuData"
              :key="index"
              :class="[
              'first-level-item',
              { active: activeFirstLevel === index },
            ]"
              @click="selectFirstLevel(index)"
          >
            <!-- 文字部分 -->
            <div class="menu-text">{{ item.name }}</div>
            <!-- 箭头图标（除了总体结果） -->
            <div
                v-if="index > 0"
                class="arrow-icon"
                :class="{
                'arrow-up': activeFirstLevel === index,
                'arrow-down': activeFirstLevel !== index,
              }"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 内容部分 - 确保不会覆盖菜单 -->
    <div class="content-section">
      <div v-if="activeFirstLevel === 0">
        <!-- 为PortraitLevel2添加容器，限制其布局 -->
        <div class="portrait-level2-container">
          <PortraitLevel2 :portraitData="portraitData" :lessonId="lessonId" />
        </div>
      </div>
      <div v-else>
        <SecondRule :data="currentData" :videoId="videoId" :on-click="handleActionButtonClick" />

        <div class="second-rule-divider"></div>

        <!-- 动态生成的内容区域：一级指标下的指标直接平铺 -->
        <el-row :gutter="20" style="margin-bottom: 20px">
          <el-col
              v-for="(child, index) in (currentData && currentData.children ? currentData.children : [])"
              :key="(currentData.id || 'group') + '-child-' + index"
              :span="getSpan(child)"
              style="margin-bottom: 20px"
          >
            <component
                v-if="componentMap[child.name]"
                :is="componentMap[child.name].component"
                :data="child"
            />

            <component
                v-else
                :is="getReportStyleComponent(child.displayType)"
                :data="child"
                :on-click="handleActionButtonClick"
            />
          </el-col>
        </el-row>
      </div>
    </div>

    <el-dialog :visible.sync="showModal" width="1338px" :modal="false" :title="modalData.title" :center="true">
      <DetailModal :data="modalData" />
    </el-dialog>
    <!-- 评分弹窗 - 使用el-dialog和el-rating -->
    <el-dialog title="评价" :visible.sync="showRatingDialog" width="30%" :close-on-click-modal="false" :modal="true"
               :append-to-body="true" :z-index="2000">
      <div class="rating-dialog-row">
        <div class="rating-dialog-main">
          <p class="rating-dialog-title">{{ ratingInfo.indicatorName }}</p>
          <el-rate v-model="currentRating" :max="5" :show-score="true" text-color="#ff9900"
                   style="font-size: 24px;" />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
                <el-button @click="handleRatingCancel">取消</el-button>
                <el-button type="primary" @click="handleRatingSubmit" :disabled="currentRating === 0">
                    提交
                </el-button>
            </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
import SecondRule from "./SecondRule.vue";
import ReportStyle1 from './reportStyle1.vue';
import ReportStyle2 from './reportStyle2.vue';
import ReportStyle3 from './reportStyle3.vue';
import ReportStyle4 from "./reportStyle4.vue";
import SysVolumeAnalysis from "./SysVolumeAnalysis.vue";
import SysSpeechRateAnalysis from "./SysSpeechRateAnalysis.vue";
import SysTeacherAudio from "./SysTeacherAudio.vue";
import SysStCoding from "./SysStCoding.vue";
import SysTeacherActivity from "./SysTeacherActivity.vue";
import SysTeacherEmoji from "./SysTeacherEmoji.vue";
import DetailModal from "./DetailModal.vue";
import PortraitLevel2 from "./PortraitLevel2.vue";
import { submit_feedback } from "@/request/api/lession.js";
export default {
  name: 'PortraitLevel4',
  components: {
    ReportStyle1, ReportStyle2, ReportStyle3,
    ReportStyle4,
    SecondRule,
    DetailModal,
    PortraitLevel2,
    SysVolumeAnalysis,
    SysSpeechRateAnalysis,
    SysTeacherAudio,
    SysStCoding,
    SysTeacherActivity,
    SysTeacherEmoji,
  },
  props: {
    portraitData: {
      type: Object,
      default: null
    },
    lessonId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      componentMap: {
        "音量时间变化分析": {
          component: "SysVolumeAnalysis",
          span: 12,
        },
        "语速时间变化分析": {
          component: "SysSpeechRateAnalysis",
          span: 12,
        },
        "教师语音综合分析": {
          component: "SysTeacherAudio",
          span: 24,
        },
        "对话编码数据S-T分析": {
          component: "SysStCoding",
          span: 24,
        },
        "教师活动情况分析": {
          component: "SysTeacherActivity",
          span: 24,
        },
        "教师行为表情情况分析": {
          component: "SysTeacherEmoji",
          span: 24,
        },
      },
      portraitEvalSlider: 70,
      // 菜单数据
      menuData: [
        {
          name: '总体结果',
        }
      ],
      //指标列表
      indicatorList: [],
      videoId: '',
      // 当前选中的一级菜单索引
      activeFirstLevel: 0,
      // 当前选中的指标数据（一级指标，其children为指标项）
      currentData: null,
      // 弹窗显示状态
      showModal: false,
      // 弹窗数据
      modalData: {
        title: '正向证据',
        videoId: '',
        indicatorName: '',
        evidences: [],
        gainList: [],
        lossList: [],
      },
      showRatingDialog: false,
      currentRating: 0,
      ratingSubmitting: false,
      ratingInfo: {
        indicatorName: '',
        id: 0,
      }
    }
  },
  watch: {
    portraitData: {
      handler(newData) {
        if (newData) {
          this.processData(newData);
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapMutations(['logout']),
    getSpan(child) {
      if (this.componentMap[child.name]) {
        return this.componentMap[child.name].span;
      }
      if (child.width) {
        return child.width;
      }
      return 24;
    },
    getReportStyleComponent(type) {
      switch (type) {
        case '1':
          return "ReportStyle1";
        case '2':
          return "ReportStyle2";
        case '3':
          return "ReportStyle3";
        case '4':
          return "ReportStyle4";
        default:
          return "ReportStyle4";
      }
    },
    processData(data) {
      this.menuData = [{
        name: '总体结果',
      }, ...(data.indicatorList || [])];
      this.videoId = data.lesson ? data.lesson.videoUrl : '';
      // 默认展示总体结果
      this.activeFirstLevel = 0;
      this.handleMenuClick(0);
    },

    // 选择一级菜单
    selectFirstLevel(index) {
      this.activeFirstLevel = index;
      this.handleMenuClick(index);
    },

    // 处理菜单点击事件
    handleMenuClick(firstIndex) {
      if (firstIndex > 0 && this.menuData[firstIndex]) {
        // 一级指标本身即为分组，其children为指标项
        this.currentData = {
          ...this.menuData[firstIndex],
        };
      } else {
        // 总体结果
        this.currentData = {
          name: '总体结果',
          isSummary: true
        };
      }
    },

    // 处理操作按钮点击事件
    handleActionButtonClick(type, childData = null) {
      const targetData = childData || this.currentData;
      if (!targetData) return;

      let extraData = {};
      try {
        extraData = targetData.extra ? JSON.parse(targetData.extra) : {};
      } catch (e) {
        extraData = {};
      }

      switch (type) {
        case 'zx':
          this.modalData.title = '正向证据';
          this.modalData.evidences = (extraData.evidences || []).filter(item => item.direction === '加分');
          this.modalData.videoId = this.videoId;
          this.modalData.gainList = targetData.gainList || [];
          this.modalData.lossList = [];
          this.modalData.indicatorName = targetData.name;
          this.showModal = true;
          break;
        case 'fx':
          this.modalData.title = '负向证据';
          this.modalData.evidences = (extraData.evidences || []).filter(item => item.direction === '扣分');
          this.modalData.videoId = this.videoId;
          this.modalData.gainList = [];
          this.modalData.lossList = targetData.lossList || [];
          this.modalData.indicatorName = targetData.name;
          this.showModal = true;
          break;
        case 'jl':
          break;
        case 'pj':
          this.ratingInfo.indicatorName = targetData.name;
          this.ratingInfo.id = targetData.id;
          this.currentRating = 0;
          this.showRatingDialog = true;
          break;
        default:
          console.log('未知按钮类型');
      }
    },

    openModal() {
      this.showModal = true;
    },

    closeModal() {
      this.showModal = false;
    },

    handleRatingSubmit() {
      if (this.currentRating > 0) {
        if (this.ratingSubmitting) return;
        this.ratingSubmitting = true;

        const formData = {
          lessonId: this.lessonId,
          groupId: this.menuData[this.activeFirstLevel] ? this.menuData[this.activeFirstLevel].id : null,
          itemId: this.ratingInfo.id,
          score: this.currentRating,
        };

        submit_feedback(formData).then(() => {
          this.$notify({ title: '成功', message: '已评价', type: 'success' });
        }).catch(() => {
          this.$notify.error({ title: '错误', message: '评分提交失败' });
        }).finally(() => {
          this.ratingSubmitting = false;
        });
      }
    },
    handleRatingCancel() {
      this.currentRating = 0;
      this.showRatingDialog = false;
    }
  },
  mounted() {
    this.handleMenuClick(this.activeFirstLevel);
  },
};
</script>
<style scoped lang="less">
/* 引入阿里巴巴普惠体常规字体 */
@font-face {
  font-family: 'AlibabaPuHuiTi';
  src: url('../../../assets/fonts/AlibabaPuHuiTi-3-55-Regular.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

/* 引入阿里巴巴普惠体粗体字体 */
@font-face {
  font-family: 'AlibabaPuHuiTi-Bold';
  src: url('../../../assets/fonts/AlibabaPuHuiTi-3-85-Bold.ttf') format('truetype');
  font-weight: bold;
  font-style: normal;
}

/* 全局字体设置 */
* {
  font-family: AlibabaPuHuiTi;
}

html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
}

.app-container {
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .menu-section {
    width: 100%;
    z-index: 10;
    background: inherit;
    padding: 10px;
    box-sizing: border-box;
    flex-shrink: 0;
  }

  /* 内容部分 - 占据剩余空间 */
  .content-section {
    flex: 1;
    width: 100%;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 20px;

    .portrait-level2-container {
      width: 100%;
      height: 100%;
      overflow: hidden;
    }

    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: rgba(0, 28, 53, 0.1);
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(5, 133, 247, 0.5);
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: rgba(5, 133, 247, 0.8);
    }

    .el-row {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;
      overflow: visible;
      margin-right: 0 !important;
      margin-left: 0 !important;
    }

    .el-col {
      box-sizing: border-box;
      min-width: 0;
    }

    .el-col>* {
      width: 100%;
      max-width: 100%;
      box-sizing: border-box;
      min-width: 0;
    }

    .text-content {
      word-wrap: break-word !important;
      word-break: break-all !important;
      overflow-wrap: break-word !important;
    }
  }

  .menu-container {
    width: 100%;
  }

  .first-level-menu {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 10px 20px;
    scrollbar-width: thin;
    scrollbar-color: rgba(5, 133, 247, 0.5) transparent;
    background: linear-gradient(180deg, rgba(0, 28, 53, 0.28) 0%, rgba(0, 28, 53, 0.24) 101%);
    box-sizing: border-box;
    border: 1px solid;
    border-image: linear-gradient(0deg, rgba(5, 133, 247, 0.3) 0%, rgba(5, 133, 247, 0.2) 50%, rgba(5, 133, 247, 0.2) 100%) 1;
  }

  .first-level-menu::-webkit-scrollbar {
    height: 6px;
  }

  .first-level-menu::-webkit-scrollbar-track {
    background: transparent;
  }

  .first-level-menu::-webkit-scrollbar-thumb {
    background: rgba(5, 133, 247, 0.5);
    border-radius: 3px;
  }

  .first-level-menu::-webkit-scrollbar-thumb:hover {
    background: rgba(5, 133, 247, 0.8);
  }

  .first-level-item {
    width: 205px;
    height: 46px;
    margin-right: 10px;
    cursor: pointer;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    background-image: url(../../../assets/image/menu-default.png);
    background-repeat: no-repeat;
    border-radius: 4px;
    font-size: 20px;
    transition: all 0.3s ease;
    white-space: nowrap;
    border: 1px solid transparent;
    box-sizing: border-box;
    position: relative;
  }

  .menu-text {
    font-weight: 500;
    color: #9ED1FF;
    font-size: 20px;
  }

  .arrow-icon {
    width: 16px;
    height: 16px;
    margin-left: 8px;
    transition: all 0.2s ease;
    background: url(../../../assets/image/arrow.png) no-repeat center center;
  }

  .arrow-down {
    transform: rotate(180deg);
  }

  .arrow-up {
    transform: rotate(0deg);
  }

  .first-level-item.active {
    color: #9ED1FF;
    background-image: url(../../../assets/image/menu-active.png);
    background-repeat: no-repeat;
  }

  .first-level-item.active .menu-text {
    color: #fff;
    font-weight: 500;
  }

  @media (max-width: 768px) {
    .first-level-menu {
      flex-wrap: wrap;
    }

    .first-level-item {
      margin-bottom: 8px;
    }
  }
}

.second-rule-divider {
  background: url(../../../assets/image/rule-divider.png) no-repeat center center;
  width: 100%;
  height: 20px;
  margin: 20px 0;
}

/deep/ .el-dialog {
  background: rgba(0, 74, 140, 0.5);
  border: 1px solid rgba(5, 133, 247, 0.5);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

/deep/ .el-dialog__header {
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 20px;

  span {
    color: #fff;
  }

  font-size: 20px;
  line-height: 20px;
  font-weight: 500;
  background: url(../../../assets/image/modal-header.png) no-repeat center center !important;
}

.rating-dialog-row {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
}

.rating-dialog-main {
  flex: 1;
  text-align: center;
}

.rating-dialog-title {
  margin-bottom: 20px;
  color: #fff;
}
</style>
